<template>
  <!-- 富文本 -->
  <div class="box">
    <div class="contract-title">
      {{ text }}
      <div class="img-x" @click="getRepayment">
        <img src="../assets/image/icons8-x.png" />
      </div>
    </div>
    <div class="wenben">
      <quill-editor
        ref="myQuillEditor"
        v-model="content"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @ready="onEditorReady($event)"
        @change="onEditorChange($event)"
      />
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import axios from "axios";
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      text: "Contract",
      content:
        "<p>Name of the borrower:{borrower}<p> ID Number: { ID number} Mobile Number: {mobile number} Loan Amount: {Loan amount} Installment Payment:{Loan term} Beneficiary Bank Name:{Beneficiary Bank} “Instal l ment Agreement”, The Lender And The Borrower Agree To And Jointly Abide By This Agreement. Adhering To The Principles Of Equity, Voluntary, Honesty And Reputation, There Is No Consensus, This Small Loan Agreement Is" // 文本内容
    };
  },
  methods: {
    // 失去焦点事件
    onEditorBlur() {},
    // 获得焦点事件
    onEditorFocus(event) {
      event.enable(false);
    },
    // 准备编辑器
    onEditorReady() {},
    // 内容改变事件
    onEditorChange() {},

    //返回上一个页面
    getRepayment() {
      this.$router.push("/myloan");
    },
    //接口函数
    getConstractInf() {
      axios
        .get(
          `/agreement/agreement/selectAgreement?uid=${+sessionStorage.getItem("token")}`)
        .then(res => {
          this.content = res.data.data;
         // //console.log(res,sessionStorage.getItem("token"));
        })
        .catch(() => {});
    }
  },
  watch: {
    // 监听文本变化内容
    content() {
      // ////console.log(this.content);
    }
  },
  mounted() {
    this.getConstractInf();
    const header = document.querySelector(".ql-toolbar");
    header.style.display = "none";
    this.$refs.myQuillEditor.quill.disable();
  }
};
</script>

<style scoped>
.box {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.wenben {
  padding: 1%;
  margin-top: 20px;
}
.contract-title {
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  color: #fff;
  height: 70px;
  line-height: 70px;
  text-align: center;
  background: linear-gradient(183deg, #a95159, #a95159);
  width: 100%;
  font-size: 30px;
  position: relative;
}
.quill-editor  {
  caret-color: transparent;
}
.img-x {
  position: absolute;
  top: 6px;
  right: 5%;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
img {
  width: 100%;
  height: 100%;
}
</style>

